<template>
    <b-container class="p-0">
        <b-container v-for="(item, index) in tradePointDaxContacts" :key="index" class="p-0 m-0">
            <b-row class="m-0 contacts-view-label">
                {{item.Type.Text}}
            </b-row>
            <b-row class="m-0 contacts-info">
                {{item.Name}}
            </b-row>
            <b-row class="m-0 contacts-info">
                {{item.Phone}}
            </b-row>  
            <hr v-if="index != tradePointDaxContacts.length-1" class="my-4"/>

        </b-container>
    </b-container>
    
</template>

<script>
export default {
    props: {
        tradePointDaxContacts: {
            type: Array,
            default: () => []
        }
    }
}
</script>